var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?[_c('busy-spinner',{attrs:{"inner-class":"p-5"}})]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }